import React, { useState, useEffect } from "react";

// components

import BlogView from "../components/blogs/BlogView.jsx";
import Navbar from "../components/Navbar/Navbar.js";
import Footer from "components/Footer/Footer.js";


export default function BlogPreview() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuToggle = () => {
        setIsMenuOpen(!isMenuOpen);
    };
  return (
    
    <>
            <Navbar />
            {/* <Sidebar
                linksData={menuDataHome}
                isMenuOpen={isMenuOpen}
                menuToggle={menuToggle}
            /> */}
            <BlogView/>
      <Footer/>
    </>
  );
}